import React from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

function Navigation() {
  const { user, logout } = useAuth();

  return (
    <Navbar expand="lg" className="navbar">
      <Container>
        <Navbar.Brand style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img 
            src="/logo-compact.svg" 
            alt="RecurOrder" 
            style={{ height: '32px', width: 'auto' }}
          />
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text className="me-3">
            Welcome, <strong>{user?.locationName || user?.username}</strong>
          </Navbar.Text>
          <Button variant="light" className="btn-logout" onClick={logout}>
            Logout
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
